module.exports = "/images/discover.svg?3716e368f8fa75c4842b1847de4c068a";